import React, { useState, useEffect } from "react";

import AuthModal from "../../components/auth/authModal";
import UnAuthModal from "../../components/auth/unAuthModal";
import AuthContext from "./index.js";

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [isAuthorised, setAuthorised] = useState(false);

    useEffect(() => {
        const localToken = localStorage.getItem("token");

        if (token) {
            localStorage.setItem("token", token);
        } else {
            if (localToken) {
                setToken(localToken);
            } else {
                setLoggedIn(false);
            }
        }
    }, [token]);

    useEffect(() => {
        const localSessionId = localStorage.getItem("sessionId");

        if (sessionId) {
            localStorage.setItem("sessionId", sessionId);
        } else {
            if (localSessionId) {
                setSessionId(localSessionId);
            } else {
                setLoggedIn(false);
            }
        }
    }, [sessionId]);

    useEffect(() => {
        const localUser = localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user"))
            : null;
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            if (localUser) {
                setUser(localUser);
            } else {
                setLoggedIn(false);
            }
        }
    }, [user]);

    useEffect(() => {
        if (user && token && sessionId) {
            setLoggedIn(true);

            setAuthorised(true);
        } else {
            setLoggedIn(false);
        }
    }, [user, token, sessionId]);

    const logout = () => {
        localStorage.clear();
        setUser(null);
        setToken(null);
        setSessionId(null);
    };

    const render = () => {
        if (isLoggedIn) {
            if (isAuthorised) {
                return children;
            } else {
                return <UnAuthModal logout={logout} />;
            }
        } else {
            return <AuthModal />;
        }
    };

    return (
        <AuthContext.Provider
            value={{
                logout,
                user,
                token
            }}
        >
            {render()}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
